export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const darkPageBg = '#3A3444';
  const darkBorder = '#2E2A36';
  const lightBorder = '#ECE8F3';
  const lightPageBg = '#FFFFFF';

  return {
    containerWrapper: {
      height: { md: 'calc(100dvh - 64px)' },
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'start',
      minHeight: 0,
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
    },
    pageWrapper: {
      flex: '1',
      height: '100%',
      p: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      fontFamily: theme.typography.fontFamily,
    },
    buttonWrapper: {
      marginLeft: '-8px',
    },
    leftWrapper: {
      height: '100%',
      maxHeight: '100%',
      width: { md: '360px' },
      backgroundColor: isDark ? darkPageBg : lightPageBg,
      borderTop: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderRight: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderBottom: 0,
      borderLeft: 0,
    },
    pageContent: {
      flex: '1',
      p: '16px',
      backgroundColor: isDark ? darkPageBg : lightPageBg,
      borderRadius: '8px',
    },
    assignmentDetailsWrapper: {
      flex: '1',
      height: '100%',
      width: '100%',
    },
    assignments: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
      height: '100%',
      width: '100%',
    },
  };
};
